import isWebos from '@accedo/xdk-device-lg-webos/esm/detection'
import WebOSTvKey from '@accedo/xdk-device-lg-webos/esm/TVKey'
import isTizen from '@accedo/xdk-device-samsung-tizen/esm/detection'
import TizenTvKey from '@accedo/xdk-device-samsung-tizen/esm/TVKey'
import isVizio from '@accedo/xdk-device-vizio-smartcast-contrib/esm/detection'
import VizioTvKey from '@accedo/xdk-device-vizio-smartcast-contrib/esm/TVKey'

export const createKeyMapping = () => {
  const keyMapping = {}

  let source

  if (isTizen) {
    source = new TizenTvKey()
  } else if (isWebos) {
    source = new WebOSTvKey()
    keyMapping[1536] = 'CursorShow'
    keyMapping[1537] = 'CursorHide'
  } else if (isVizio) {
    source = new VizioTvKey()
  }

  if (!source) {
    return
  }

  const covertVKeyToString = (val) => {
    let startIndex = val.indexOf('vkey:')
    if (startIndex === -1) {
      return null
    }
    startIndex += 'vkey:'.length
    let subStr = val.substring(startIndex)
    subStr = subStr.replace(subStr[0], subStr[0].toUpperCase())
    let index = subStr.indexOf('-')
    while (index >= 0) {
      subStr = subStr.replace('-', '')
      let firsPart = subStr.substring(0, index)
      let secondPart = subStr.substring(index)
      secondPart = secondPart.replace(secondPart[0], secondPart[0].toUpperCase())
      subStr = firsPart + secondPart
      index = subStr.indexOf('-')
    }

    // On xdk some keys are called 'Ok' while lightningjs is expecting 'Enter'
    if (subStr.toLowerCase() === 'ok') {
      subStr = 'Enter'
    }

    return subStr
  }

  // eslint-disable-next-line no-prototype-builtins
  if (source.hasOwnProperty('_keys')) {
    for (const [key, value] of Object.entries(source._keys)) {
      keyMapping[key] = covertVKeyToString(value.id)
    }
  }

  return keyMapping
}
